import { createElement } from 'react';
import { ScrollBoard } from '@jiaminghi/data-view-react';
const DataVScrollBoard = (props) => {
    const { style, data, onClick, onMouseOver, ...rest } = props;
    const config = {
        ...rest,
        data: JSON.parse(JSON.stringify(data)),
    };
    return createElement(ScrollBoard, { config: config, style: style, onClick: onClick, onMouseOver: onMouseOver });
};
export default DataVScrollBoard;
